// Pure timing helpers for the DB Interface session. The server enforces the same one-hour
// cap on Firebase `auth_time`; these only drive the countdown and the local auto-logout.

export const SESSION_MAX_AGE_MILLISECONDS = 60 * 60 * 1000;
export const SESSION_WARNING_THRESHOLD_MILLISECONDS = 5 * 60 * 1000;

export const SESSION_ENDED_REASONS = {
  timeLimitReached: "timeLimitReached",
  serverRejectedSession: "serverRejectedSession",
  userLoggedOut: "userLoggedOut",
};

export const SESSION_ENDED_MESSAGES = {
  [SESSION_ENDED_REASONS.timeLimitReached]: "Your 1-hour session ended. Sign in again to continue.",
  [SESSION_ENDED_REASONS.serverRejectedSession]: "The server ended your session (1-hour limit). Sign in again.",
  [SESSION_ENDED_REASONS.userLoggedOut]: "You have been logged out.",
};

// `authTime` is the string Firebase returns in getIdTokenResult().authTime (RFC 1123 date).
export function computeSessionEndsAt(authTime) {
  const authTimeMilliseconds = new Date(authTime).getTime();
  if (!Number.isFinite(authTimeMilliseconds)) return null;
  return authTimeMilliseconds + SESSION_MAX_AGE_MILLISECONDS;
}

export function formatSessionEndTime(milliseconds) {
  return new Date(milliseconds).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

// "43 min" while there is plenty of time, "4:59" style once under ten minutes.
export function formatRemainingDuration(milliseconds) {
  const clamped = Math.max(0, milliseconds);
  const totalSeconds = Math.ceil(clamped / 1000);
  if (totalSeconds >= 10 * 60) {
    return `${Math.ceil(totalSeconds / 60)} min`;
  }
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}
